import { devtools } from 'config/devtools'
import { create } from 'zustand'

import { UsePromoScenariosParams } from './types'

export const usePromoScenariosParams = create<UsePromoScenariosParams>()(
  devtools(
    (set) => ({
      filters: {},
      setFilters: (filters) => set({ filters }),
      clearFilters: () => set({ filters: {} }),
      search: '',
      setSearch: (search) => set({ search }),
      clearSearch: () => set({ search: '' }),
      ordering: null,
      setOrdering: (ordering) => set({ ordering }),
      clearOrdering: () => set({ ordering: null }),
    }),
    {
      store: 'promoScenariosParams',
    },
  ),
)
